var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { Dialog, Paper, Slide } from '@mui/material';
import React from 'react';
import { ariaContentDefaultId, ariaSubTitleId, ariaTitleAdditionalInfoId, ariaTitleId } from './ariaIds';
const Transition = React.forwardRef(function Transition(props, ref) {
    return (React.createElement(Slide, Object.assign({ direction: 'left', ref: ref }, props), props.children));
});
// TODO implement configurable width with CUI-286
const defaultWidth = 400;
/**
 * Slideout modal dialog component with transition animation from the right.
 *
 * @param {object} props - Component props.
 * @param {boolean} props.open - Whether the modal is open.
 * @param {() => void} props.onClose - Function called when the modal is requested to close.
 * @param {string} [props.ariaContentId] - Optional ID used for ARIA accessibility description.
 * @param {(event: React.KeyboardEvent) => void} [props.onKeyDown] - Keydown handler for keyboard events.
 * @param {SxProps<Theme> | SxProps<Theme>[]} [props.sx] - Optional style overrides using system props.
 * @param {React.ReactNode} props.children - Modal content.
 * @returns {JSX.Element} The rendered slideout modal dialog.
 */
export const ModalSlideout = (_a) => {
    var { open, onClose, ariaContentId, onKeyDown, sx } = _a, props = __rest(_a, ["open", "onClose", "ariaContentId", "onKeyDown", "sx"]);
    const ariaLabelIds = [ariaTitleId, ariaSubTitleId].join(' ');
    const ariaDescribeIds = [ariaTitleAdditionalInfoId, ariaContentId !== null && ariaContentId !== void 0 ? ariaContentId : ariaContentDefaultId].join(' ');
    return (React.createElement(Dialog, { TransitionComponent: Transition, open: open, onClose: onClose, onKeyDown: onKeyDown, "aria-labelledby": ariaLabelIds, "aria-describedby": ariaDescribeIds, "data-test": props['data-test'] },
        React.createElement(Paper, { sx: [
                {
                    display: 'flex',
                    flexDirection: 'column',
                    position: 'fixed',
                    top: 0,
                    right: 0,
                    bottom: 0,
                    borderRadius: 0,
                    '&:focus': {
                        outline: 'none',
                    },
                    width: { xs: '100%', sm: defaultWidth },
                },
                ...(Array.isArray(sx) ? sx : [sx]),
            ], elevation: 8, "data-test": props['data-test'] }, props.children)));
};
